import React from "react";
import {ExternalLink} from "../../../utils/cms/types";
import i18n from "i18next";
import {ExternalLinkRow} from "./ExternalLinkRow";

type Props = {
  externalLinks: ExternalLink[];
};

export const ExternalLinks = ({externalLinks}: React.PropsWithChildren<Props>) => {
  if (externalLinks.length === 0) {
    return null;
  } else {
    return (
      <section className="ph2 ph0-sm pt6-sm" aria-labelledby="book-appointment-h2">
        <h2 id="book-appointment-h2" className="fs32 fs24-md ls-25 wsnw ph6 ph4-sm">
          {i18n.t("What brings you in?")}
        </h2>
        {externalLinks.map(externalLink => (
          <ExternalLinkRow key={externalLink.url} externalLink={externalLink} />
        ))}
      </section>
    );
  }
};
